// MIT © 2017 azu
"use strict";
/**
 * Minimal Log Chunk object
 */

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LogChunk =
/**
 * @param {*} [log]
 * @param {Object} [payload]
 * @param {UseCase} [useCase]
 * @param {number} timeStamp
 */
function LogChunk(_ref) {
    var log = _ref.log,
        payload = _ref.payload,
        useCase = _ref.useCase,
        timeStamp = _ref.timeStamp;

    _classCallCheck(this, LogChunk);

    this.log = log;
    this.payload = payload;
    this.useCase = useCase;
    this.timeStamp = timeStamp;
};

exports.default = LogChunk;
module.exports = exports["default"];
//# sourceMappingURL=LogChunk.js.map


//////////////////
// WEBPACK FOOTER
// ./~/almin-logger/lib/log/LogChunk.js
// module id = 138
// module chunks = 0